<template>
  <div
    class="gradient-overlay"
    :class="{ 'top-to-bottom': topToBottom }"
    :style="compSolidColor ? compSolidColor : ''"
  />
</template>

<script>
export default {
  name: 'UtilGradientOverlay',
  props: {
    topToBottom: {
      type: Boolean,
      default: false
    },
    opacityGreen: Number,
    opacityBlack: Number,
    opacityWhite: Number
  },
  computed: {
    compSolidColor() {
      if (this.opacityGreen) {
        return `background: rgba(119, 142, 87, ${this.opacityGreen})`
      }

      if (this.opacityBlack) {
        return `background: rgba(0, 0, 0, ${this.opacityBlack})`
      }

      if (this.opacityWhite) {
        return `background: rgba(255, 255, 255, ${this.opacityWhite})`
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.gradient-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 2;
  background: rgb(255, 255, 255);
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.01) 61%, rgba(0, 0, 0, 0.65) 87%);
}

.gradient-overlay.top-to-bottom {
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.1) 1%,
    rgba(0, 0, 0, 0.3) 78%,
    rgba(0, 0, 0, 0.4) 87%
  );
}
</style>
